import { DateSelectionPaneComponent } from "./DateSelectionPaneComponent";
import { MonthSelectionPaneComponent } from "./MonthSelectionPaneComponent";
import React from "react";
import { activateDialog } from "../../lib/dialogFocus";
require("./dateselector.scss");
import { DateTime } from "luxon";
export default class DateSelectorComponent extends React.Component {
    constructor(props) {
        super(props);
        this.wrapRef = React.createRef();
        this.state = {
            selectorShown: false,
            selectedDt: DateTime.fromISO(this.props.dt),
            buttonRef: React.createRef()
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.dt !== state.selectedDt.toFormat("yyyy-MM-dd")) {
            return { selectedDt: DateTime.fromISO(props.dt) };
        }
        return null;
    }
    componentDidUpdate(_prevProps, prevState) {
        var _a, _b, _c, _d;
        if (this.state.selectorShown && !prevState.selectorShown) {
            // The pane is a dialog for the keyboard: Tab stays in it, Escape closes it, and the focus goes back to
            // the button that opened it. The focus goes into it, to the chosen day when there is one.
            const pane = () => { var _a, _b; return (_b = (_a = this.wrapRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(".ds-pane")) !== null && _b !== void 0 ? _b : null; };
            this.deactivate = activateDialog(pane, () => this.hideSelector());
            const target = (_b = (_a = pane()) === null || _a === void 0 ? void 0 : _a.querySelector(".selected-date:not([disabled])")) !== null && _b !== void 0 ? _b : (_c = pane()) === null || _c === void 0 ? void 0 : _c.querySelector("button:not([disabled])");
            target === null || target === void 0 ? void 0 : target.focus();
        }
        else if (!this.state.selectorShown && prevState.selectorShown) {
            (_d = this.deactivate) === null || _d === void 0 ? void 0 : _d.call(this);
            this.deactivate = undefined;
        }
    }
    componentWillUnmount() {
        var _a;
        (_a = this.deactivate) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    toggleSelector() {
        this.setState({ selectorShown: !this.state.selectorShown });
    }
    hideSelector() {
        this.setState({ selectorShown: false });
    }
    selectDt(dt) {
        !!this.props.onDateSelected && this.props.onDateSelected(dt.toFormat("yyyy-MM-dd"));
        this.setState({ selectedDt: dt, selectorShown: false });
    }
    onShow(startDt, endDt) {
        return !!this.props.onShow ? this.props.onShow(startDt.toFormat("yyyy-MM-dd"), endDt.toFormat("yyyy-MM-dd")) : Promise.resolve(null);
    }
    render() {
        const mode = this.props.mode || "week";
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "dateselector", ref: this.wrapRef }, (() => {
                var _a;
                switch (mode) {
                    case "month":
                        return (React.createElement(React.Fragment, null,
                            React.createElement("button", { type: "button", className: "btn btn-outline-dark dateselectortoggle", "aria-haspopup": "dialog", "aria-expanded": this.state.selectorShown, onClick: () => this.toggleSelector(), ref: this.state.buttonRef },
                                React.createElement("span", null,
                                    React.createElement("i", { className: "fa-regular fa-calendar" }),
                                    this.state.selectedDt.toFormat(this.props.format || "MMM yyyy"))),
                            React.createElement(MonthSelectionPaneComponent, { shown: this.state.selectorShown, selectedDt: this.state.selectedDt, maxDt: this.props.maxDt, onCancelled: () => this.hideSelector(), onSelected: (dt) => this.selectDt(dt), buttonRef: this.state.buttonRef })));
                    case "date":
                        return (React.createElement(React.Fragment, null,
                            React.createElement("button", { type: "button", className: "btn btn-outline-dark dateselectortoggle", "aria-haspopup": "dialog", "aria-expanded": this.state.selectorShown, onClick: () => this.toggleSelector(), ref: this.state.buttonRef },
                                React.createElement("span", null,
                                    React.createElement("i", { className: "fa fa-calendar-days" }), (_a = this.props.label) !== null && _a !== void 0 ? _a : this.state.selectedDt.toFormat(this.props.format || "EEE dd-MM yyyy"))),
                            React.createElement(DateSelectionPaneComponent, { shown: this.state.selectorShown, selectedDt: this.state.selectedDt, onCancelled: () => this.hideSelector(), onSelected: (dt) => this.selectDt(dt), onShow: (startDt, endDt) => this.onShow(startDt, endDt), buttonRef: this.state.buttonRef })));
                    default:
                        return React.createElement(React.Fragment, null);
                }
            })())));
    }
}
